import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export var CheckoutType;
(function (CheckoutType) {
    CheckoutType[CheckoutType["ApplePay"] = 0] = "ApplePay";
    CheckoutType[CheckoutType["StandardCheckout"] = 1] = "StandardCheckout";
})(CheckoutType || (CheckoutType = {}));
export const CheckoutStatusContext = createContext(undefined);
export const CheckoutStatusProvider = (props) => {
    const [pendingSubmission, setPendingSubmission] = useState(null);
    const [pendingConfirmation, setPendingConfirmation] = useState(false);
    const [timedOut, setTimedOut] = useState(false);
    return (_jsx(CheckoutStatusContext.Provider, { value: {
            pendingSubmission,
            pendingConfirmation,
            timedOut,
            pendingCheckout: pendingSubmission !== null || pendingConfirmation,
            startSubmitting: (type) => {
                setPendingSubmission(type);
                setPendingConfirmation(false);
                setTimedOut(false);
            },
            startConfirming: () => {
                setPendingSubmission(null);
                setPendingConfirmation(true);
            },
            settle: () => {
                setPendingSubmission(null);
                setPendingConfirmation(false);
            },
            triggerTimeout: () => {
                setPendingConfirmation(false);
                setTimedOut(true);
            },
            dismissTimeout: () => setTimedOut(false),
        }, children: props.children }));
};
export const useCheckoutStatus = () => {
    const context = useContext(CheckoutStatusContext);
    if (!context) {
        throw new Error('useCheckoutStatus must be used within CheckoutStatusProvider');
    }
    return context;
};
